import { render } from "./ArticleView.vue?vue&type=template&id=741822d0"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=741822d0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__